export function canContainRectangle(containerWidth, containerLength, targetWidth, targetLength) {
    return ((containerLength >= targetLength && containerWidth >= targetWidth) ||
        (containerLength >= targetWidth && containerWidth >= targetWidth));
}
export class Rectangle {
    constructor(width, length) {
        this.width = width;
        this.length = length;
    }
    canContainRectangle(containWidth, containLength) {
        return canContainRectangle(this.getWidth(), this.getLength(), containWidth, containLength);
    }
    getWidth() {
        return this.width;
    }
    getLength() {
        return this.length;
    }
    setWidth(width) {
        this.width = width;
    }
    setLength(length) {
        this.length = length;
    }
    equalsRectangle(rec2) {
        return this.getWidth() === rec2.getWidth() && rec2.getLength() === rec2.getLength();
    }
}
